import { AutoLockFormsLevelType, FormNames } from '../autoLockForms.constants';

const formFields = [
  {
    name: 'firstName',
    label: 'First Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'lastName',
    label: 'Last Name',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'emailAddress',
    label: 'Email Address',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'phoneNumber',
    label: 'Phone Number',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'creditRating',
    label: 'Credit Rating',
    levelType: AutoLockFormsLevelType.FIELD,
  },
  {
    name: 'isFirstTimeHomeBuyer',
    label: 'Is First Time Home Buyer',
    levelType: AutoLockFormsLevelType.FIELD,
  },
];

export const leadPersonalInformationForm = {
  name: FormNames.LEAD,
  label: 'Personal Information',
  levelType: AutoLockFormsLevelType.FORM,
  children: formFields,
};
